import { Component, Input, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { ComputeService } from '../services/compute.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../../../auth/auth.service';
import { genericDateFormatter } from '../../../dataprotection/dataprotection-common/common-renderers';
import { RefreshSharedService } from '../../../../refresh-shared-service';
import { setVcdRedirectUrlCookie } from '../../../../../common/utils/utils';

@Component({
    selector: 'vapp',
    providers: [
        ComputeService, TranslateService
    ],
    styles: [require('./vapp.scss')],
    template: require('./vapp.html')
})

export default class Vapp implements OnChanges {
    private jsonData: any;
    private loadedvapp: boolean = false;
    private vappIdFromRoute: any;
    private subscription: Subscription;
    private isDeleteVappPopupVisible: boolean = false;
    private isEditVappPopupVisible: boolean = false;
    private isEmptyEntity: boolean = false;
    private vappSSOURL: string;
    private creationDate: string = "";
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private isDpsHealthy: boolean = false;

    constructor(public computeService: ComputeService, 
                public authService: AuthService,
                private translateService: TranslateService, 
                private route: ActivatedRoute,
                private rss: RefreshSharedService) {
        translateService.use(GlobalVariables.LOCALE);
        this.rsService = rss;
        this.currentClassName = 'Vapp';   
    }

    ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
            this.handleEmittedValues(item);
        });
        this.route.params.forEach((params: Params) => {
            this.vappIdFromRoute = params['id3'];
            this.rsService.setParam({
                'loadedComponent': this.currentClassName,
                'detailPageIDName': params['id3'],
                'shouldReloadInventoryTree': true
            });
            this.getVappDetails();
        });
    }

  handleEmittedValues(item) {
        if (item.loadedComponent === this.currentClassName) {
            this.jsonData = [];
            this.getVappDetails();
        }
  }

    ngOnChanges(changes) {
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }

    getVappDetails() {
        if (this.vappIdFromRoute && this.vappIdFromRoute !== '') {
            this.loadedvapp = false;
            this.subscription = this.computeService.getVappDetails(this.vappIdFromRoute)
                .subscribe(
                    res => {
                        this.jsonData = res[0];
                        this.loadedvapp = true;
                        this.isDpsHealthy = (this.authService.DPS_HEALTH && this.authService.DPS_HEALTH.isHealthy) ? true : false;                      
                        this.isEmptyEntity = this.checkIfEmptyEntity(res);
                        this.creationDate = (this.jsonData && this.jsonData.creationDate) ? genericDateFormatter(this.jsonData.creationDate) : "-"
                        this.setVappSSOURL(this.jsonData.orgName, this.vappIdFromRoute);
                    },
                    error => this.logError(error, 'get vApp details'),
                    () => this.logOperationCompleted('get vApp details')
                );
        } else {
            this.logError('Could not get vApp id from the route');
        }
    }

    checkIfEmptyEntity(restResult): boolean {
        return (restResult && restResult.constructor === Array && restResult.length === 0) ? true : false;
    }

    logError(error, origin: String = '') {
        console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
    }

    logOperationCompleted(msg: string) {
        console.log('Operation Completed: ', msg);
    }

    setVappSSOURL(orgName: string, vappId: string) {
        if (!orgName || orgName === '') {
            return;
        }

        // vapp id is in the format of "vapp-{vapp-id}". We need only {vapp-id} for the SSO.
        let index = vappId.indexOf('-');
        vappId = vappId.substring(index + 1);
        let url = document.createElement('a');
        url.href = window.location.href;
        this.vappSSOURL = url.protocol + '//' + url.host + '/compute/cloud/org/' + orgName.toLowerCase()
            + '/#/vAppDiagram?vapp=' + vappId;
    }

    onMangeInVcd = ($event) => {
        if (this.vappSSOURL) {
            let orgName = this.jsonData.orgName;
            setVcdRedirectUrlCookie(orgName, this.vappSSOURL);
            window.open(this.vappSSOURL, '_blank');
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/vapp/vapp.component.ts